import React from 'react';
import {
    Paper,
    Typography,
    Stack,
    Button,
    Box,
    Chip,
    Grid
} from '@mui/material';
import {
    Add,
    Assessment,
    Notifications,
    People,
    Category,
    Security,
    Refresh,
    Download
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickActions = ({ onRefreshStats }) => {
    const navigate = useNavigate();

    const quickActions = [
        {
            id: 'create-badge',
            label: 'Create New Badge',
            icon: <Add />,
            color: '#43a047',
            action: () => navigate('/admin/badges'),
            primary: true
        },
        {
            id: 'view-users',
            label: 'View All Users',
            icon: <People />,
            color: '#2196f3',
            action: () => navigate('/admin/users')
        },
        {
            id: 'manage-categories',
            label: 'Manage Categories',
            icon: <Category />,
            color: '#ff9800',
            action: () => navigate('/admin/categories')
        },
        {
            id: 'view-analytics',
            label: 'View Analytics',
            icon: <Assessment />,
            color: '#9c27b0',
            action: () => navigate('/admin/stats')
        },
        {
            id: 'system-logs',
            label: 'System Logs',
            icon: <Security />,
            color: '#f44336',
            action: () => navigate('/admin/logs')
        },
        {
            id: 'refresh-data',
            label: 'Refresh Dashboard',
            icon: <Refresh />,
            color: '#607d8b',
            action: onRefreshStats,
            variant: 'outlined'
        }
    ];

    return (
        <Paper elevation={2} sx={{ mt: 6, p: 4, borderRadius: 3, background: '#f8f9fa' }}>
            <Typography variant="h5" fontWeight={700} sx={{ mb: 3, color: '#1b5e20' }}>
                ⚡ Quick Actions
            </Typography>

            <Grid container spacing={2}>
                {quickActions.map((action) => (
                    <Grid item xs={12} sm={6} md={4} key={action.id}>
                        <Button
                            variant={action.primary ? 'contained' : action.variant || 'outlined'}
                            startIcon={action.icon}
                            onClick={action.action}
                            fullWidth
                            sx={{
                                py: 1.5,
                                borderRadius: 2,
                                fontWeight: 600,
                                textTransform: 'none',
                                ...(action.primary ? {
                                    background: `linear-gradient(135deg, ${action.color}, ${action.color}dd)`,
                                    '&:hover': {
                                        background: `linear-gradient(135deg, ${action.color}dd, ${action.color}bb)`,
                                        transform: 'translateY(-1px)'
                                    }
                                } : {
                                    color: action.color,
                                    borderColor: action.color,
                                    '&:hover': {
                                        borderColor: action.color,
                                        background: `${action.color}08`,
                                        transform: 'translateY(-1px)'
                                    }
                                }),
                                transition: 'all 0.2s ease'
                            }}
                        >
                            {action.label}
                        </Button>
                    </Grid>
                ))}
            </Grid>

            {/* Additional Quick Stats */}
            <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e0e0e0' }}>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
                    💡 System Status
                </Typography>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                    <Chip
                        icon={<Assessment />}
                        label="All Systems Operational"
                        sx={{
                            background: 'linear-gradient(135deg, #4caf50, #66bb6a)',
                            color: 'white',
                            fontWeight: 600
                        }}
                    />
                    <Chip
                        icon={<Security />}
                        label="Security: Active"
                        sx={{
                            background: 'linear-gradient(135deg, #2196f3, #42a5f5)',
                            color: 'white',
                            fontWeight: 600
                        }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        Last updated: {new Date().toLocaleTimeString()}
                    </Typography>
                </Stack>
            </Box>
        </Paper>
    );
};

export default QuickActions;
